<page-banner imageUrl="page-banner-2.png" headingText="Our history"></page-banner>

<div class="content-container">

  <div class="container">

    <div class="row timeline-row">
      <div class="col-12">
        <h2>Overview</h2>
        <p>MW Wines has been operating since 1989. MW Wines has grown to be one of Australia’s premier suppliers of old and rare fine wines in Australia and abroad. MW Wines also specialises in the provision of private and fully managed cellars and operates Australia’s premier wine auction house.</p>
        <p>MW Wines is wholly owned by Nick Stamford, a passionate wine collector and consumer. Nick’s enthusiasm, his depth of wine knowledge and his strong business background will ensure that MW Wines remains a staunchly independent supplier of old and rare wines. Nick believes strongly in providing wine consumers with a wide range of old, rare and fine wines and a customer service beyond that available in Australia’s major chains.</p>
      </div>
    </div>

  </div>

  <div class="container">

    <div class="row timeline-row">
      <div class="col-12 timeline-heading">
        <h2>History</h2>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-3 text-right timeline-row-left">
        <h3>1989</h3>
        <p>MW Wines established as RMG Auctions, an independent wine auction house specialising in old and rare fine wines in Brunswick, Victoria.</p>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-6 timeline-row-right">
        <h3>2003</h3>
        <p>MW Wines moves to specialised climate controlled premises in Abbotsford, Victoria.</p>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-3 text-right timeline-row-left">
        <h3>2004</h3>
        <p>MW Wines commences online auctions in addition to live auctions.</p>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-6 timeline-row-right">
        <h3>2005</h3>
        <p>The last live auction is held in late 2005 marking the progression to purely online auctions.</p>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-3 text-right timeline-row-left">
        <h3>2010</h3>
        <p>Nick Stamford acquires MW Wines.</p>
      </div>
    </div>

    <div class="row timeline-row">
      <div class="col-12 col-lg-3 offset-lg-6 timeline-row-right">
        <h3>2013</h3>
        <p>MW Wines moves to a purpose built climate controlled storage facility contained within a heritage listed building in Cambridge Street, Collingwood, Victoria.</p>
      </div>
    </div>

  </div>

</div>
